import React from 'react';
import { useTranslation } from 'react-i18next';
import { Map, List } from 'lucide-react';
import { analyticsService } from '../../lib/analytics/analyticsService';
import { useSection } from '../../hooks/useSection';

interface ViewToggleProps {
  view: 'map' | 'list';
  onChange: (view: 'map' | 'list') => void;
  config: any;
  translations: Record<string, Record<string, string>>;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({
  view,
  onChange,
  config,
  translations
}) => {
  const { i18n } = useTranslation();
  const section = useSection();

  const getTranslatedText = (key: string): string => {
    const translation = translations[key];
    if (!translation) return key;
    return translation[i18n.language] || translation.fr || key;
  };

  const handleViewChange = (newView: 'map' | 'list') => {
    analyticsService.trackEvent({
      event_type: 'view',
      event_name: 'view_change',
      event_data: {
        section_id: section.id,
        section_name: section.names.fr || 'Unknown Section',
        section_type: 'event',
        view_type: newView
      }
    });
    onChange(newView);
  };

  return (
    <div 
      className="flex bg-white rounded-full overflow-hidden shadow-lg"
      style={{ padding: '4px' }}
    >
      <button
        onClick={() => handleViewChange('map')}
        className={`flex items-center px-6 py-2 rounded-full transition-all duration-200`}
        style={{ 
          backgroundColor: view === 'map' ? config['major-color'] : 'transparent',
          color: view === 'map' ? '#fff' : '#000'
        }}
      >
        <Map size={18} className="mr-2" />
        <span className="text-sm font-medium">{getTranslatedText('view_map')}</span>
      </button>
      <button
        onClick={() => handleViewChange('list')}
        className={`flex items-center px-6 py-2 rounded-full transition-all duration-200`}
        style={{ 
          backgroundColor: view === 'list' ? config['major-color'] : 'transparent',
          color: view === 'list' ? '#fff' : '#000'
        }}
      >
        <List size={18} className="mr-2" />
        <span className="text-sm font-medium">{getTranslatedText('view_list')}</span>
      </button>
    </div>
  );
};